import React from 'react';
import { Container, Row, Col } from 'shards-react';

const BlankLayout = ({ children, noNavbar, noFooter }) => (
  <Container fluid className="icon-sidebar-nav">
    <Row>
      <Col className="main-content col" tag="main">
        {children}
      </Col>
    </Row>
  </Container>
);

export default BlankLayout;
